














































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/newIndex'
import appconst from '@/lib/appconst'
@Component({
  components: {},
})
export default class MallDiyNewList extends AbpBase {
  modal = false
  previewUrl = ''
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '微页面名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '开始时间',
      slot: 'startTime',
      align: 'center',
    },
    {
      title: '结束时间',
      slot: 'endTime',
      align: 'center',
    },
    {
      title: '最后修改时间',
      slot: 'lastUpdateTime',
      align: 'center',
    },
    {
      title: '是否设成首页',
      slot: 'isHomePage',
      align: 'center',
    },
    {
      title: '启用',
      slot: 'isActive',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 220,
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  isCheckAll = false

  created() {
    this.getMallDiyList()
  }

  /**
   * 获取微页面列表
   */
  getMallDiyList() {
    let { page } = this
    MallConfig.getMallDiyList(page.maxResultCount, page.currentPage).then((res) => {
      page.totalCount = res.data.totalCount
      this.tableData = res.data.items
    })
  }

  /**
   * 启用/禁用
   */
  isActiveChange(e, id) {
    MallConfig.setIsActive([id], e).then((res) => {
      this.getMallDiyList()
    })
  }

  isHomePageChange(id) {
    MallConfig.setHomePage(id).then((res) => {
      this.getMallDiyList()
    })
  }

  /**
   * 新增/编辑
   */
  editFn(row?) {
    console.log(row)
    this.$router.push({
      name: 'homeSetting',
      query: {
        id: row ? row.id : '',
        isHomePage: row ? row.isHomePage : false,
        isDinghuo: row ? '' : 'true'
      },
    })
  }

  /**
   * 复制
   */
  copyFn(row?) {
    console.log(row)

    this.$Modal.confirm({
      title: '提示',
      content: `您确定要复制此模板吗？`,
      onOk: () => {
        this.loading = true
        MallConfig.copyMallDiy(row.id)
          .then((res) => {
            console.log(res)
            this.getMallDiyList()
            this.loading = false
          })
          .catch((err) => {
            console.log(err)
            this.loading = false
          })
      },
    })
  }

  /**
   * 删除
   */
  deleteFn(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        MallConfig.deleteMallDiy([id])
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '删除成功' })
            this.getMallDiyList()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  /**
   * 批量启用/禁用
   */
  activeSelectd(active) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.loading = true
      let list: any = selection.map((item) => {
        return item.id
      })
      MallConfig.setIsActive(list, active)
        .then((res) => {
          this.loading = false
          this.getMallDiyList()
        })
        .catch((err) => {
          this.loading = false
        })
    } else {
      this.$Notice.warning({
        title: '请先选择微页面',
      })
    }
  }

  /**
   * 批量删除
   */
  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.$Modal.confirm({
        title: '提示',
        content: `删除无法恢复, 是否继续?`,
        onOk: () => {
          this.loading = true
          let list: any = selection.map((item) => {
            return item.id
          })
          MallConfig.deleteMallDiy(list)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '删除成功' })
              this.getMallDiyList()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择微页面',
      })
    }
  }

  changePage(e) {
    this.page.currentPage = e
    this.getMallDiyList()
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.getMallDiyList()
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  preview(wxaCodeParamId) {
    this.previewUrl = `${
      appconst.remoteServiceBaseUrl
    }/api/WeChatManagement/WxOpen/WxaCode?page=pages/diy/index&IsUnLimit=true&scene=${wxaCodeParamId}`
    this.modal = true
  }
}
